import { PropsWithChildren } from "react";
import { Provider } from "react-redux";
import { store } from "./index";

/**
 * Provides the Redux store to the app.
 *
 * Kept above the top-level error boundary so the crash fallback also has store
 * context.
 */
const ReduxProvider = ({ children }: PropsWithChildren) => {
  return <Provider store={store}>{children}</Provider>;
};

export default ReduxProvider;
